/** Button-action inactive values: 1 = enabled, 2 = disabled (matches Continue/submit conventions). */
export const PASSIVE_SUBMIT_INACTIVE_ENABLED = 1;
export const PASSIVE_SUBMIT_INACTIVE_DISABLED = 2;

export function anyMcqAnswersChecked(answerElements) {
  return Array.from(answerElements || []).some((el) => el.classList.contains('checked'));
}

export function notesTrimmedTextAllowsSubmit(textarea) {
  return Boolean(textarea?.value?.trim());
}

/**
 * Derive passive submit enablement on the button-action slice (DOM only; no DUS write).
 */
export function applyDerivedPassiveSubmitInactive({
  submitSlice,
  application,
  buttonActionIdentifier,
  enabled,
  submitButton,
}) {
  const inactive = enabled ? PASSIVE_SUBMIT_INACTIVE_ENABLED : PASSIVE_SUBMIT_INACTIVE_DISABLED;

  if (submitSlice) {
    submitSlice.setAttribute(`data-${buttonActionIdentifier}-inactive-value`, String(inactive));
    const buttonAction = application?.getControllerForElementAndIdentifier(
      submitSlice,
      buttonActionIdentifier,
    );
    if (buttonAction && Object.prototype.hasOwnProperty.call(buttonAction, 'inactiveValue')) {
      buttonAction.inactiveValue = inactive;
      return;
    }
  }

  if (!submitButton) return;
  submitButton.disabled = !enabled;
  if (!enabled) {
    submitButton.setAttribute('aria-disabled', 'true');
  } else {
    submitButton.removeAttribute('aria-disabled');
  }
}
